import React from 'react';
import { Link, useParams } from "react-router-dom";

import JudeteDataService from '../services/JudeteDataService';
import MonitorService from '../services/MonitorService';
import Message from '../message/Message';
import unixTimeToDateString from '../services/Date'

import './Anunt.css';

class ButtonSave extends React.Component {

    save( licitatieId ) {
        JudeteDataService.saveLicitatie(licitatieId).then( response => {
            if( response.added === 1) {
                this.props.onMessage("Salvata");
            }
            else {
                this.props.onMessage("A fost o eroare");
            }
        });

        this.props.onUpdateReqested();
    }

    removeSaved( licitatieId ) {
        MonitorService.sendEvent("Anunt interesat id=" + licitatieId);
        JudeteDataService.removeLicitatie(licitatieId).then( response => {
            if ( response.removed === 1) {
                this.props.onMessage("Stearsa");
            }
            else {
                this.props.onMessage("A fost o eroare");
            }
        });
        this.props.onUpdateReqested();
    }

    render() {

        if ( this.props.salvata === 1 ) {
            return (
                <div id="save-btn" className="details-btn unselectable" onClick={() => { this.removeSaved(this.props.licitatieId) }}>Sterge</div>
            )
        }
        else {
            return (
                <div id="save-btn" className="details-btn unselectable" onClick={() => { this.save(this.props.licitatieId) }}>Interesanta</div>
            )
        }
    }
}

class ButonRaporteaza extends React.Component {

    raporteaza( licitatieId ) {
        JudeteDataService.raporteazaLicitatie(licitatieId).then( response => {
            if( response.added === 1) {
                this.props.onMessage("Raportata");
            }
            else {
                this.props.onMessage("A fost o eroare");
            }

            this.props.onUpdateReqested();
        });
    }


    render() {

        if ( this.props.raportata === 0 ) {
            return (
                <div id="report-btn" className="details-btn unselectable" onClick={() => { this.raporteaza(this.props.licitatieId) }}>Gresita</div>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}

class ButonIgnore extends React.Component {
    // Expect to get props:
    // anunt: AnuntIdWrapper {licitatie, for, id}
    // ignore: 0/1 1 if already ignored

    // type AnuntIdWrapper {licitatie, for, id}
    raporteaza( anunt ) {
        MonitorService.sendEvent("Anunt ne-interesant id=" + anunt.id);
        JudeteDataService.ignoraAnunt(anunt.id, anunt.for, anunt.licitatie).then( response => {
            if( response.added === 'Added') {
                this.props.onMessage("Cerere efectuata");
            }
            else {
                this.props.onMessage("A fost o eroare: " + response.added);
            }

            this.props.onUpdateReqested();
        });
    }


    render() {
        if ( this.props.ignore === 0 ) {
            return (
                <div id="report-btn" className="details-btn unselectable" onClick={() => { this.raporteaza(this.props.anunt) }}>Neinteresanta</div>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}

/**
 * Expect to receive in params:
 * anuntId: id of anunt, licitatie for case or terrain
 * for: casa/teren
 * licitatie: true/false
 * desktop: true/false
 */
class Anunt extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            totalPrice: 0,
            priceMp: 0,
            localitate: "",
            message: "",
            pulled: 1
        }

    }

    componentDidMount() {
        const anuntId  = this.props.params.anuntId;

        this.getData(anuntId).then( response => {
            this.setState({
                id: response.id,
                title: response.title,
                totalPrice: response.total_price,
                priceMp: response.price_mp,
                priceUnit: response.price_unit,
                surface: response.surface,
                judet: response.judet,
                localitate: response.localitate,
                dataScanare: unixTimeToDateString(response.data_scanare),
                dataLicitatie: response.data_licitatie,
                detalii: response.detalii,
                salvata: response.salvata,
                raportata: response.raportata,
                pdf: response.pdf,
                content: response.content,
                cf: response.cf,
                nrCadastru: response.nr_cadastru,
                pulled: response.pulled,

                ignored: 0, // TODO get this from database
            });

            // Salvez detele pentru a sti ce judet sa deschid in pagina principala
            JudeteDataService.dropJud = response.judet;

            // Salvez id-ul pentru a sti ce rand sa marchez in dropdown
            JudeteDataService.lastDropdownSelectedId = this.props.params.licitatieId;

            // Updatez si licitatiile din lista licitatiiAll daca este cazul
            const inList = JudeteDataService.licitatiiAll.find(l => l.id === response.id);
            if ( !!inList ) {
                inList.salvata = response.salvata;
            }

        }, reason => {
            console.error(reason);
        });
    }

    getData(id) {
        if (this.props.for === 'teren') {
            if (this.props.licitatie) {
                return JudeteDataService.getLicitatie(id);
            } else {
                return JudeteDataService.getAnunt(id);
            }
        } else if (this.props.for ==='casa') {
            if (this.props.licitatie) {
                throw Error('Not implemented - nu am parsat licitatii pentru case');
            } else {
                return JudeteDataService.getAnuntCase(id);
            }
        } else {
                throw Error('for property not accepted: ' + this.props.for);
        }
    }

    downloadPdf( id, url ) {
        let a  = document.createElement('a');
        a.href = url;
        a.download = id + '.pdf';
        a.click();
    }

    updateRequested() {
        JudeteDataService.lastGetRaportDataJudet = null;
        this.componentDidMount();
    }

    openDetaliiLink(detaliiLink) {
        window.open( detaliiLink );
    }

    showMessage(message) {
        this.setState({
            message: message
        });
    }

    closeMessage() {
        this.setState({
            message: ""
        });
    }

    pullData(licitatieId) {
        if ( this.state.pulled === 1) {
            // Inseamna ca deja am luat detaliile parsate pentru anuntul asta
            return;
        }

        this.setState({ pulled: 1 });

        JudeteDataService.pullData(licitatieId).then( response => {
            console.log(response);
            this.setState({
                content: response.content,
                dataLicitatie: response.data_licitatie,
                pdf: response.pdf,
                cf: response.cf,
                nrCadastru: response.nr_cadastru
            });
        });
    }

    /**
     * Pulled poate fi 1 = a fost parsata pagina de detalii
     * 0 = nu a fost parsata. Voi arata butonul dezactivat 
     * @param { pulled } pulledValue 
     */
    getCssClassForPullBtn( pulledValue ) {
        if ( pulledValue === 1) {
            return "pull-deactivate unselectable";
        }
        else {
            return "pull-active unselectable";
        }
    }

    elementDataLabel() {
        if ( !this.state.dataLicitatie || this.state.dataLicitatie.length === 0 ) {
            return null;
        }
        else {
            return ( <div className="property">Data</div> )
        }
    }

    elementDataValoare() {
        if ( !this.state.dataLicitatie || this.state.dataLicitatie.length === 0 ) {
            return null;
        }
        else {
            return ( <div className='value date-value'>{ this.state.dataLicitatie}</div>)
        }
    }

    elementLocalitate( localitate ) {
        return {
            label: function() {
                if ( !!localitate && localitate.length > 0 ) {
                    return ( <div className='property'>Localitate</div> )
                }
                else {
                    return null;
                }
            },
            valoare: function() {
                if ( !!localitate && localitate.length > 0 ) {
                    return ( <div className='value'>{ localitate.toLowerCase() }</div> )
                }
                else {
                    return null;
                }
            }
        }
    }

    render() {

        return (
            <div id="content">

                <div className='buttons-direction'>
                    {/* BUTON TOATE ANUNTURILE */}
                    { !this.props.licitatie &&  this.props.for === 'teren' && <Link id="link" to={`/anunturi/judet/${this.state.judet}`}><div className="button-direction">Toate anunturile</div></Link> }
                    { !this.props.licitatie &&  this.props.for === 'casa' &&  <Link id="link" to={`/case/judet/${this.state.judet}`}><div className="button-direction">Toate anunturile</div></Link> }

                    {/* BUTTON TOATE LICITATIILE */}
                    { this.props.licitatie && <Link id="link" to={`/judet/${this.state.judet}`}><div className="button-direction">Toate licitatiile</div></Link> }

                    {/* BUTTON HARTA */}
                    <Link id="link" className="harta-btn button-direction" to={`/`}><div>Harta</div></Link>
                </div>

                {/* PULL DATA BUTTON */}
                <div id='pull-data-btn' className={this.getCssClassForPullBtn(this.state.pulled)} onClick={ () => this.pullData(this.state.id) }>Pull data</div>


                <div id="properties-container-desktop">

                    <div></div>

                    {/* COLOANA CENTRALA */}
                    <div>

                        <div className='tags'>
                            { !this.props.licitatie && <div className='tag anunt'>Anunt</div> }
                            { this.props.licitatie && <div className='tag licitatie'>Licitatie</div> }
                            { this.props.for === 'teren' && <div className='tag teren'>Teren</div> }
                            { this.props.for === 'casa' && <div className='tag'>Casa</div> }
                        </div>


                        {/* TITLU */}
                        <div id="title-anunt-a"  className='desktop' >
                            <div id="title-content-column">
                                <div id='title-text'>{this.state.title}</div>

                                {/* RAND CF SI NUMAR CADASTRU */}
                                <div id="rand-subtitle">
                                    { !!this.state.cf && <div className="val-subtitle" >CF {this.state.cf.toUpperCase()}</div> }
                                    { !!this.state.nrCadastru && <div className="val-subtitle" >Cadastru {this.state.nrCadastru.toUpperCase()}</div> }
                                </div>


                            </div>

                        </div>

                        {/* PROPRIETATILE */}
                        <div id="properties-desktop">
                            <div className="property">Total price</div>
                            <div className='value'> { this.state.totalPrice } {this.state.priceUnit}</div>

                            <div className="property">Price MP</div>
                            <div className='value'> { parseFloat(this.state.priceMp).toFixed(2) }</div>

                            <div className="property">Surface </div>
                            <div className='value'>{ this.state.surface }</div>

                            <div className="property">Judet </div>
                            <div className='value'>{ this.state.judet }</div>

                            { this.elementLocalitate( this.state.localitate ).label() }
                            { this.elementLocalitate( this.state.localitate ).valoare() }

                            { this.elementDataLabel() }
                            { this.elementDataValoare() }

                            {/* Nu cred e folositor sa mai arat id-ul */}
                            {/* <div className='property'>Id</div> */}
                            {/* <div className='value'> { this.state.id }</div> */}
                        </div>

                        {/* BUTOANELE */}
                        <div className="details-btn" onClick={() => {this.openDetaliiLink(this.state.detalii) }}>Deschide</div>

                        { !!this.state.pdf && <div className="details-btn" onClick={() => {this.downloadPdf(this.state.id, this.state.pdf) }}>Publicatie</div> }

                        <ButtonSave salvata={this.state.salvata} 
                            licitatieId={this.state.id} 
                            onUpdateReqested={() => this.updateRequested()} 
                            onMessage={(mes) => this.showMessage(mes)} />

                        <ButonIgnore ignore={this.state.ignored} 
                            anunt={{id: this.state.id, licitatie: this.props.licitatie, for: this.props.for}}
                            onUpdateReqested={() => this.updateRequested() } 
                            onMessage={(mes) => this.showMessage(mes)} />

                        <ButonRaporteaza raportata={this.state.raportata} 
                            licitatieId={this.state.id} 
                            onUpdateReqested={() => this.updateRequested() } 
                            onMessage={(mes) => this.showMessage(mes)} />

                    </div>

                    <div></div>

                </div>


                { !!this.state.content && <div id="details-content-desktop">{this.state.content}</div>}

                <Message message={this.state.message} 
                    show={this.state.message.length > 0} 
                    onClose={ () => this.closeMessage() } />


            </div>
        )
    }

}

// eslint-disable-next-line
export default (props) => (
    <Anunt {...props} params={useParams()} /> 
);
